var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewFavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9961 5.50003C18.9961 11.7444 9.99647 17 9.99647 17C9.99647 17 0.996094 11.6667 0.996094 5.51268C0.996094 3.00003 2.99609 1.00003 5.49609 1.00003C7.99609 1.00003 9.99609 4.00003 9.99609 4.00003C9.99609 4.00003 11.9961 1.00003 14.4961 1.00003C16.9961 1.00003 18.9961 3.00003 18.9961 5.50003Z",
    stroke: "#050505",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFavIcon);
export default __webpack_public_path__ + "static/media/newFavIcon.28d5abae5f65adfff8d2fa0cf2f3ba55.svg";
export { ForwardRef as ReactComponent };